import { useState } from "react";
import { useParams } from "react-router-dom";
import VerifyAccountParams from "../../models/common/PageParms";
import RegisterService from "../../services/authentication-service";
import toasterUtils from "../../utils/toaster-utils";
import VerificationModel from "../../models/authentication/VerificationModel";
import modalUtils from "../../utils/modal-utils";
import loaderUtils from "../../utils/loader-utils";
import { useHistory } from "react-router";

const VerifyAccountComponent = () => {
    const history = useHistory();
    const [verificationCode, setVerificationCode] = useState<string>("");
    const requestParams: VerifyAccountParams = useParams();

    const verifyAccount = () => {
        var verifyModel: VerificationModel = {
            verificationCode: verificationCode,
            verificationString: requestParams.verificationCode
        };
        modalUtils.showLoader();
        RegisterService.VerifyUser(verifyModel).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            setTimeout(() => {
                history.push("/login");
            }, 1000);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr registering user.");
        });
    }

    return (
        <section className="bg-light md">
            <div className="container-body">
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <div className="quform-element form-group">
                            <div className="quform-input">
                                <input type="text" className="form-control" placeholder="Verification Code" onChange={e => setVerificationCode(e.target.value)} autoComplete="off" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3"></div>
                </div>
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <div className="quform-submit-inner">
                            <button className="butn primary mt-4" type="submit" onClick={() => verifyAccount()}><span>Verify</span></button>
                        </div>
                    </div>
                    <div className="col-md-3"></div>
                </div>
            </div>
        </section>
    );
};
export default VerifyAccountComponent;